// A helper to determine if a node is inside an 'Array'
import { type TreeCursor } from '@lezer/common';

import { formulaParser } from '../lezer-syntax-parser';
import { possibleVariablePatterns } from '../tokens';

const isInsideArray = (cursor: TreeCursor): boolean => {
  let depth = 0;
  while (cursor.parent()) {
    depth++;
    if (cursor.name === 'Array') {
      while (depth-- > 0) {
        cursor.next();
      } // Go back to original position
      return true;
    }
  }
  while (depth-- > 0) {
    cursor.next();
  } // Go back to original position
  return false;
};

export const stringifyVariableNamesInsideArray = (input: string): string => {
  const tree = formulaParser.parse(input);
  const cursor = tree.cursor();
  let result = '';
  let lastPos = 0;

  do {
    if (cursor.name === 'VariableName' && isInsideArray(cursor.node.cursor())) {
      const { from, to } = cursor;
      const original = input.slice(from, to);
      result += input.slice(lastPos, from);
      result += JSON.stringify(original);
      lastPos = to;
    }
  } while (cursor.next());

  result += input.slice(lastPos);
  return result;
};

export const reverStringifyVariablesInArray = (input: string): string => {
  if (!input.startsWith('[') || !input.endsWith(']')) {
    return input;
  }

  try {
    const parsedArray = JSON.parse(input);
    if (!Array.isArray(parsedArray)) {
      return input;
    }
    const arrayItems = parsedArray.map((varOrString) => {
      const isVariable = possibleVariablePatterns.some((pattern) => pattern.test(varOrString));
      if (isVariable) {
        return varOrString;
      }
      // If it's a string that doesn't match variable patterns, keep it was with quotes
      return JSON.stringify(varOrString);
    });
    return `[${arrayItems.join(', ')}]`;
  } catch {
    return input;
  }
};
